<template>
  <div class="page flex-col">
    <div class="box_1 flex-col justify-end">
      <div class="section_1 flex-row">
        <img
          class="image_1"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng5eb7835fc957042f4b02048930b15033b02aadc08574d830df2c060761b9879a.png"
        />
        <img
          class="image_2"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng4b858c76b9deb5b3941827f27d1c8ac1b586ba98eec1392060201b04c690af4c.png"
        />
        <span class="text_1">自由随心·Al随行·慧安智远</span>
        <span class="text_2">首页</span>
        <span class="text_3">产品方案</span>
        <span class="text_4">案例展示</span>
        <span class="text_5">新闻动态</span>
        <span class="text_6">关于慧安</span>
      </div>
      <div class="section_2 flex-row"><div class="block_1 flex-col"></div></div>
    </div>
    <div class="box_2 flex-col">
      <span class="text_7">江苏慧安智远智能医疗闪耀湖嘉麻醉年会</span>
      <span class="text_8">
        (湖州长兴，2025年7月20日晚)&nbsp;为期两天的&nbsp;2025年湖州嘉兴两市麻醉学学术年会暨临床麻醉质控年会&nbsp;于今日在风景秀丽的&nbsp;太湖龙之梦瑞峰国际大酒店&nbsp;圆满闭幕。本次盛会汇聚了湖州、嘉兴及周边地区麻醉学领域的顶尖专家、学科带头人和临床骨干，共同探讨麻醉学前沿进展、质控管理与技术创新。江苏慧安智远智能医疗科技有限公司&nbsp;作为智能医疗领域的创新力量，携其核心产品&nbsp;“麻精药品智能管理系统”&nbsp;惊艳亮相&nbsp;7号展位，成为会议期间备受瞩目的焦点。
      </span>
      <img
        class="image_3"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPngb066839b046371e5899717360787ebd6cd1d162ae3384c80df438aa86bfc1069.png"
      />
      <span class="text_9">工作人员现场演示系统核心功能</span>
      <span class="text_10">
        (图片说明：技术人员正在向参观专家演示系统操作界面，展示药品精准追踪、智能存取等核心功能)
      </span>
      <div class="section_3 flex-row justify-between">
        <div class="group_1 flex-col"></div>
        <div class="group_2 flex-col"></div>
      </div>
      <span class="text_11">公司代表与多位麻醉科主任、药学专家进行深入交流，探讨系统落地应用细节</span>
      <span class="paragraph_1">
        圆满收官，期待再会
        <br />
        <br />
        随着本次年会的成功落幕，江苏慧安智远的湖嘉之行也画上了圆满的句号。通过此次盛会，公司不仅展示了领先的技术实力和产品价值，更与众多潜在客户和行业伙伴建立了紧密联系，收获了宝贵的市场反馈与合作意向。
      </span>
    </div>
    <div class="box_3 flex-col">
      <div class="text-wrapper_1 flex-row">
        <span class="text_12">公司信息</span>
        <span class="text_13">二维码</span>
        <span class="text_14">商务合作</span>
      </div>
      <div class="image-wrapper_1 flex-row justify-between">
        <img
          class="image_4"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng1c0a871b3fb97b29a5d07e5b71ab2c9223c1b2d4b7269d3443356771d6bdf9aa.png"
        />
        <img
          class="image_5"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng1c0a871b3fb97b29a5d07e5b71ab2c9223c1b2d4b7269d3443356771d6bdf9aa.png"
        />
        <img
          class="image_6"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng1c0a871b3fb97b29a5d07e5b71ab2c9223c1b2d4b7269d3443356771d6bdf9aa.png"
        />
      </div>
      <div class="group_3 flex-row">
        <span class="paragraph_2">
          江苏慧安智远智能医疗科技有限公司
          <br />
          <br />
          地址：无锡市惠山区惠山大道1719-5号二层B区&nbsp;
          <br />
          电话：0510-83582015
          <br />
          邮箱：huianzhiyuan&#64;qq.com
          <br />
          官网：www.hilears.com&nbsp;
          <br />
        </span>
        <div class="image-text_1 flex-col justify-between">
          <div class="image-wrapper_2 flex-col">
            <img
              class="image_7"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng6d89f0dbceb8cf2835772a0f780d8d18a85d8ad63f161fa6700239ef2ee1b0b1.png"
            />
          </div>
          <span class="text-group_1">
            关注公众号：HILEARS和尔思
            <br />
          </span>
        </div>
        <span class="text_15">卢先生&nbsp;&nbsp;0510-83582015</span>
      </div>
      <div class="text-wrapper_2 flex-row">
        <span class="text_16">
          Copyright&nbsp;©&nbsp;&nbsp;2022&nbsp;-&nbsp;forever&nbsp;&nbsp;江苏慧安智远智能医疗科技有限公司所有&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;苏ICP备17033009号-4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;江苏慧安智远智能医疗科技有限公司
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />